export const ItemTypes = {
    COLUMN: 'column',
    COLUMN_WRAPPER: 'column',
    COMPONENT: 'component',
    PAGE_SETTINGS: 'page_settings',
    WRAPPER: 'wrapper',
};
